import { Component, Input, OnInit } from '@angular/core';
import { TasacionesService } from '../../../services/tasaciones.service';
import { FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GridOptions } from 'ag-grid';
import { DateHelper } from '../../../models/NgDateCustomAdapter';
import { AuthService } from '../../../services/auth.service';
import { CellDateFormatterComponent } from '../../cell-date-formatter/cell-date-formatter.component';
import { CellHyperlinkCustomComponent } from '../../cell-hyperlink-custom/cell-hyperlink-custom.component';
import { CellImageFormatterComponent } from '../../cell-image-formatter/cell-image-formatter.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { DialogComponent } from '../../dialog/dialog.component';
import { TasacionEditPsFormComponent } from '../../tasacion-edit/tasacion-edit-ps-form/tasacion-edit-ps-form.component';
import { PsAsignacionTasacionFormComponent } from '../ps-asignacion-tasacion-form/ps-asignacion-tasacion-form.component';

@Component({
  selector: 'app-ps-tasacion-list',
  templateUrl: './ps-tasacion-list.component.html',
  styleUrls: ['./ps-tasacion-list.component.scss']
})
export class PsTasacionListComponent implements OnInit {


  public baseEditUrl = "/tasacion/edit/";
  public baseEditText = "Editar";

  public translate: TranslateService;
  public columnDefs: any[];
  public rowData: any;
  searchTerm: FormControl = new FormControl();
  public gridApi;
  public tooltipShowDelay = 500
  // public gridApi;
  gridOptions: GridOptions;
  @Input() idPs: number;

  createColumnDef() {
    const columnDefs = [
      {
        headerName: '',
        field: 'id', suppressFilter: true, suppressSorting: true,
        cellRendererFramework: CellHyperlinkCustomComponent,
        cellRendererParams: {
          destUrl: '/tasacion/edit/', hyperlinkText: 'Abrir tasación',
          iconClass: 'fa-lg fas fa-file-alt text-success'
        },
        pinned: 'left',
        width: 55

      },
      { headerName: 'Of. Fact.', headerTooltip: "Oficina facturación", field: 'oficinaFacturacion.oficinaCode', tooltipField: 'oficinaFacturacion.oficinaCode', width: 70 },
      { headerName: this.translate.instant('tasaciones.header_codtasacion'), headerTooltip: "Código tasación", field: 'codigoTasacion', tooltipField: 'codigoTasacion', width: 120 },
      {
        headerName: this.translate.instant('tasaciones.referenciaBanco'), headerTooltip: this.translate.instant('tasaciones.referenciaBanco'),
        field: 'referenciaBanco', tooltipField: 'referenciaBanco', width: 110
      },
      {
        headerName: 'Nº Presupuesto', headerTooltip: 'Nº presupuesto',
        field: 'nPresupuesto', tooltipField: 'nPresupuesto', width: 100
      },
      {
        headerName: this.translate.instant('tasaciones.header_cliente'), headerTooltip: this.translate.instant('tasaciones.header_cliente'),
        field: 'cliente.displayName', tooltipField: 'cliente.displayName', minWidth: 350
      },
      {
        headerName: this.translate.instant('tasacion_edit.camp_solicitante'), headerTooltip: this.translate.instant('tasacion_edit.camp_solicitante'),
        field: 'clienteSolicitante.displayName', tooltipField: 'clienteSolicitante.displayName', minWidth: 350
      },
      {
        headerName: this.translate.instant('tasaciones.header_tipoInmueble'), headerTooltip: this.translate.instant('tasaciones.header_tipoInmueble'),
        field: 'tipoInmueble.nombre', tooltipField: 'tipoInmueble.nombre', width: 120
      },
      {
        headerName: 'Localidad', headerTooltip: "Localidad", field: 'localidad', tooltipField: 'localidad', width: 100
      },
      {
        headerName: 'F. Alta', headerTooltip: "Fecha Alta", field: 'createdDate', cellRendererFramework: CellDateFormatterComponent, width: 100
      },
      {
        headerName: this.translate.instant('tasaciones.deadline'), headerTooltip: "Deadline", field: 'deadline',
        cellRendererFramework: CellDateFormatterComponent, cellStyle: function (params) {
          const now = new Date();
          const deadline = new Date(params.value);
          deadline.setUTCHours(0, 0, 0, 0);
          let color = '';
          if (deadline >= now) {
            color = 'green'
          } else {
            color = '#D40501' //color rojo
          }

          return { color: color }
        }, width: 100
      },
      { headerName: "C. ABC", headerTooltip: "Categorización ABC", field: 'categorizacionABC', tooltipField: 'categorizacionABC', width: 50 },
      {
        headerName: this.translate.instant('tasaciones.header_estado'), headerTooltip: this.translate.instant('tasaciones.header_estado'), field: 'estadoIncidencia', tooltipField: 'estadoIncidencia',
        cellRendererFramework: CellImageFormatterComponent, minWidth: 200, maxWidth: 300
      },
      {
        headerName: this.translate.instant('tasaciones.header_estadoFacturado'), headerTooltip: this.translate.instant('tasaciones.header_estadoFacturado'),
        field: 'estadosFacturacion.nombre', tooltipField: 'estadosFacturacion.nombre', width: 140
      },
      {
        headerName: this.translate.instant('tasaciones.header_tecnico'), headerTooltip: this.translate.instant('tasaciones.header_tecnico'),
        field: 'tasador.nombreCompleto', tooltipField: 'tasador.nombreCompleto', width: 130
      },
      {
        headerName: "Imp. Presupuestado", headerTooltip: this.translate.instant('tasaciones.header_importePresupuestado'),
        field: 'importePresupuestado', tooltipField: 'importePresupuestado', width: 80,
      },
      {
        headerName: "Tiempo consumido", headerTooltip: 'Tiempo consumido',
        field: 'tiempoConsumido', width: 115,
      }
    ];

    return columnDefs;
  }



  constructor(private _tasacionesService: TasacionesService, private _router: Router, private _route: ActivatedRoute,
    public _authService: AuthService, _translateService: TranslateService, private dateHelper: DateHelper, public matDialog: MatDialog) {


    this.translate = _translateService;

    this.columnDefs = this.createColumnDef();
    this.gridOptions = {
      floatingFiltersHeight: 50
    }
  }

  ngOnInit() {
    this.getTasaciones();

  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  public getTasaciones() {

    this._tasacionesService.getTasacionesByIdPs(this.idPs).subscribe(data => {
      this.rowData = data;
    });
  }

  asignarTasacion() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '30%';
    dialogConfig.data = {
      title: 'Asociar Expediente',
      confirmText: 'Aceptar',
      component: PsAsignacionTasacionFormComponent,
      id: this.idPs
    };

    const ref = this.matDialog.open(DialogComponent, dialogConfig);
    ref.componentInstance.onSaveEvent = this.onSaveCallback.bind(this);
  }

  async onSaveCallback(cInstance: any): Promise<boolean> {
    let result = false;
    if(await cInstance.onSubmit()) {
      this.getTasaciones();
      result = true;
    } else {
      result = false;
    }

    return result;
  }

  

}
